import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row wrap" }, "Oil analysis history", -1 /* HOISTED */)
const _hoisted_3 = { id: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_ctx.equipment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "q-mb-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row justify-between card-title" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_apexchart, {
                    type: "bar",
                    height: "350",
                    options: _ctx.chartOptions,
                    series: _ctx.series
                  }, null, 8 /* PROPS */, ["options", "series"])
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : _createCommentVNode("v-if", true)
}